import styled from 'styled-components';

const StyledFeaturedVoice = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 21px;
  gap: 16px;
  background: linear-gradient(
    135deg,
    #fff3eb 0%,
    rgba(254, 252, 232, 0.5) 50%,
    #ffe5d4 100%
  );

  .featured-voice-header {
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
    cursor: pointer;
  }
`;

export { StyledFeaturedVoice };
